export enum ManualComplianceStatus {
  Compliant = 'COMPLIANT',
  NonCompliant = 'NON_COMPLIANT',
  RiskRelease = 'RISK_RELEASE',
  RiskReleaseAllIn = 'RISK_RELEASE_ALL_IN',
  AffordableHousing = 'AFFORDABLE_HOUSING',
  NotAvailable = 'NOT_AVAILABLE',
  Ineligible = 'INELIGIBLE',
  ThirdParty = 'THIRD_PARTY',
}
